import React, { useEffect, useRef, useState } from "react";
import pdf from "../gazeta-pażdziernik-second/Respublica-pazdziernika.pdf"

const PageGazetaOctoberFirst = () => {
  useEffect(() => {
    window.location.href = pdf
  })
};

export default PageGazetaOctoberFirst
